import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import React, { useCallback, useEffect, useState } from 'react';
import fontFamilyOptions from './Utils/FontFamilyOptions';
import { saveCanvasState } from '../../Actions/Rutab/HistoryActions';
export const FontSelectorDialog = React.memo(({ canvas, activeTextObject, onClose }) => {
    const menuOption = useSelector((state) => state.decalEditor.menuOption);
    const dispatch = useDispatch();
    const [fontFamily, setFontFamily] = React.useState(activeTextObject === null || activeTextObject === void 0 ? void 0 : activeTextObject.fontFamily);
    const [searchTerm, setSearchTerm] = useState('');
    useEffect(() => {
        if ((menuOption === null || menuOption === void 0 ? void 0 : menuOption.type) === 'Type' || (menuOption === null || menuOption === void 0 ? void 0 : menuOption.type) === 'Image') {
            onClose();
        }
    }, [menuOption, onClose]);
    if (!activeTextObject)
        return null;
    const isSelected = (typeKey) => {
        return activeTextObject.fontFamily === typeKey;
    };
    const getButtonClass = (typeKey) => {
        return `button hollow type-select-btn${isSelected(typeKey) ? ' selected' : ''}`;
    };
    const toggleFontStyleDialog = useCallback((font) => {
        if (activeTextObject) {
            activeTextObject.set({
                fontFamily: font,
            });
            setFontFamily(font);
            canvas.renderAll();
            dispatch(saveCanvasState(canvas));
        }
    }, [activeTextObject, canvas]);
    const filteredFonts = fontFamilyOptions.filter(font => font.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
        font.type.toLowerCase().includes(searchTerm.toLowerCase()));
    return (_jsxs("div", { className: "side-dialog open", children: [_jsx("div", { className: "side-dialog-header", children: _jsx("button", { className: "side-dialog-close", onClick: () => onClose(), children: "\u00D7" }) }), _jsx("div", { className: "side-dialog-content", children: _jsx("div", { className: "grid-container", children: _jsx("div", { className: "grid-x grid-padding-x", children: _jsxs("div", { className: "cell", children: [_jsx("h2", { className: "type-form-title", children: "V\u00E4lj teckensnitt" }), _jsxs("div", { className: "search-bar mb-2", children: [_jsx("input", { type: "text", placeholder: "S\u00F6k & hitta teckensnitt...", value: searchTerm, onChange: (e) => setSearchTerm(e.target.value) }), _jsx("i", { className: "fas fa-search" })] }), filteredFonts.map((font) => (_jsx("div", { className: "card border-bottom", children: _jsxs("div", { className: "card-section ", children: [_jsxs("div", { className: "type-option-label", children: [_jsx("label", { style: { fontFamily: font.type }, children: font.label }), _jsx("button", { className: getButtonClass(font.type), type: "button", onClick: () => toggleFontStyleDialog(font.type), children: isSelected(font.type) ? 'Vald' : 'Välj' })] }), _jsx("p", { className: "type-option-description", style: { fontFamily: font.type }, children: font.exampleText })] }) }, font.id))), _jsx("button", { className: "button expanded type-submit-btn", onClick: () => onClose(), children: "ST\u00C4NG" })] }) }) }) })] }));
}, (prevProps, nextProps) => {
    if (!!prevProps.activeObject !== !!nextProps.activeObject)
        return false;
    if (!prevProps.activeObject ||
        !nextProps.activeObject ||
        prevProps.activeObject !== nextProps.activeObject)
        return false;
    if (prevProps.canvas !== nextProps.canvas)
        return false;
    return true;
});
